import { type BaseEnterpriseRepository } from "../../_Bases/BaseEnterpriseRepository";
import { type LocalDatabaseEnterprise } from "../../_Bases/BaseEnterpriseRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBEnterpriseRepository extends BaseIndexedDBRepository<
    LocalDatabaseEnterprise
> implements BaseEnterpriseRepository {
    public readonly source: InternalIndexedDBDatabase["enterprises"];
    protected readonly dataTypeName = "Enterprise";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.enterprises;
    }

    public search(needle: string): Promise<Array<LocalDatabaseEnterprise>> {
        if(!needle) {
            return this.all();
        }

        return this.source
            .where("name")
            .startsWithIgnoreCase(needle)
            .toArray();
    }
}
